import {
  Datagrid,
  Filter,
  List,
  ListProps,
  SearchInput,
  TextField,
} from "react-admin";
import { Helmet } from "react-helmet";
import CustomPriceField from "../../components/CustomPriceField";
import CustomDateField from "../../components/CustomDateField";

const GeneralLedgerFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
  </Filter>
);

const GeneralLedgerList = (props: ListProps) => {
  return (
    <>
      <Helmet>
        <title>General Ledgers</title>
      </Helmet>

      <List
        {...props}
        exporter={false}
        hasCreate={false}
        actions={null}
        filters={<GeneralLedgerFilter />}
        filterDefaultValues={{ Type: "general" }}
        sort={{ field: "createdAt", order: "DESC" }}
        bulkActionButtons={false}
        title=" "
      >
        <Datagrid>
          <TextField label="Descriptions" source="description" emptyText="-" />
          <CustomDateField label="Date" source="date" emptyText="-" />
          <TextField label="Type" source="type" emptyText="-" />
          <CustomPriceField label="Debit" source="debit" />
          <CustomPriceField label="Credit" source="credit" />
        </Datagrid>
      </List>
    </>
  );
};
export default GeneralLedgerList;
